import { useCallback, useState } from "react";

/**
 * Two languages, Khmer first in the market's own script. Kept as a flat
 * dictionary because there are a few dozen strings, not a few thousand.
 */

export type Lang = "en" | "kh";

const EN = {
  brand: "Moo Moo Farms",
  deliverTo: "Deliver to",
  milkToday: "Milk today",
  milkTomorrow: "Milk tomorrow",
  cutoffOpen: "Order before 9 in the morning",
  cutoffShut: "Today's truck has left. Order now for tomorrow.",
  left: "left",
  search: "Search milk",
  popular: "Popular now",
  allMilk: "All milk",
  products: "products",
  inStock: "In stock",
  onlyLeft: "Only %1 left",
  soldOut: "Sold out",
  perBottle: "per bottle",
  bottles: "bottles",
  viewCart: "View cart",
  yourCart: "Your cart",
  cartEmpty: "Nothing in the cart yet",
  cartEmptySub: "Add some milk and it shows up here.",
  subtotal: "Subtotal",
  delivery: "Delivery",
  free: "Free",
  total: "Total",
  checkout: "Checkout",
  back: "Back",
  yourName: "Your name",
  phone: "Phone",
  address: "Delivery address",
  driverNote: "Note for the driver",
  whereTo: "Where do we deliver?",
  useMyLocation: "I am at home now, use my location",
  locating: "Finding you…",
  dragMap: "Move the map until the red pin is on your house",
  confirmPin: "Deliver here",
  changePin: "Change",
  pinSet: "Pin set",
  quoting: "Working out the distance…",
  estimated: "estimated",
  outsideArea: "That location is outside our delivery area.",
  callUs: "Call us on %1",
  quoteFailed: "We could not work out the distance. Try moving the pin.",
  needPin: "Drop a pin on the map first",
  pricedAtCheckout: "Delivery priced at checkout from your pin",
  gpsDenied: "Location access was refused. Drag the map to your gate instead.",
  feeHow: "Delivery is $0.40 plus $0.10 a kilometre from our Chbar Ampov office.",
  cashOnDelivery: "Cash on delivery",
  cashHow: "Our driver collects %1 when the milk arrives. KHQR is coming.",
  paymentInvoice: "Invoiced, 30 days",
  paid: "Paid",
  unpaid: "Not yet paid",
  placeOrder: "Place order",
  sending: "Sending…",
  yourOrder: "Your order",
  stagePlaced: "Order placed",
  stageConfirmed: "Confirmed by Moo Moo",
  stagePacked: "Packed",
  stageOnTheWay: "On the way to you",
  stageDelivered: "Delivered",
  stageCancelled: "Cancelled",
  driver: "Driver",
  orderAgain: "Order again",
  retry: "Try again",
  loading: "Loading the shop…",
  staleWarning: "Stock may be a few minutes out of date.",
  offline: "You are offline. Your basket is saved.",
  wholesale: "Business",
  retail: "Customer",
  poNumber: "Your PO number",
  terms: "Payment terms",
  termsValue: "30 days, invoice on delivery",
  noFeeWholesale: "No delivery charge: your order rides our existing route.",
  crateStep: "Business orders move in crates of 6 bottles.",
  businessCode: "Business code",
  businessCodeHow: "Ask the office for your code to order at trade terms.",
  enter: "Enter",
  cancel: "Cancel",
  notePlaceholder: "Gate code, floor, landmark",
  poPlaceholder: "e.g. GF-0912",
  priceNote: "The price is confirmed by our system when the order is placed, not by this page.",
  stillBooking: "Your order is with us. It is still being written into our office system.",
  noMatch: "Nothing matches that search.",
  clampNotice: "Only %1 left of %2.",
  errName: "Please enter your name.",
  errPhone: "Enter a Cambodian mobile number, e.g. 012 345 678.",
  errAddress: "Please give an address the driver can find.",
  errPin: "Drop a pin on the map so we know where to deliver.",
  errStale: "We cannot reach our stock system right now. Please try again in a moment.",
  errUnavailable: "Some milk is no longer available in that quantity. Please check your cart.",
  errEmpty: "Everything in your basket has just sold out.",
  errOutside: "That location is outside our delivery area.",
  errWholesaleClosed: "Business ordering is not open yet.",
  errWholesaleCode: "That business code is not right.",
  errOffline: "You appear to be offline. Check your connection and try again.",
  errNetwork: "We could not reach Moo Moo Farms. Please try again.",
  errGeneric: "Something went wrong. Please try again.",
  shopError: "The shop could not be loaded.",
  addLabel: "Add %1",
  errRateLimited: "Too many requests from this phone. Please wait a minute.",
  reorderThis: "Order this again",
  reorderLast: "Order your last order again",
  backToShop: "Back to the shop",
  officeTitle: "Office",
  officePin: "Office PIN",
  officeEnter: "Open",
  officeOff: "The office page is not set up. Ask James to set OFFICE_PIN.",
  officeBadPin: "That PIN is not right.",
  officeLocked: "Too many tries. Wait ten minutes.",
  tabToday: "Today",
  tabOpen: "Open",
  tabAll: "All",
  countToDeliver: "To deliver",
  countOnWay: "On the way",
  countDelivered: "Delivered",
  countCash: "Cash collected",
  noOrders: "No orders here.",
  call: "Call",
  map: "Map",
  takeIt: "Take it out",
  handedOver: "Delivered",
  deliveredWhat: "What was handed over?",
  reasonWhy: "Why short?",
  paymentAtDoor: "Payment at the door",
  payCash: "Cash received",
  payKhqrDone: "Paid by KHQR",
  payNotYet: "Not paid",
  confirmDelivery: "Confirm delivery",
  cancelOrder: "Cancel order",
  cancelWhy: "Why cancel?",
  reasonBroken: "Broken",
  reasonReturn: "Return",
  reasonExpiry: "Near expiry",
  reasonRefused: "Refused",
  reasonOther: "Other",
  noteLabel: "Note",
  ordered: "ordered",
  invoice: "Invoice",
  signOut: "Lock",
  businessAsk: "Business customer?",
  switchRetail: "Customer prices",
  addMore: "Add more milk",
  atCheckout: "At checkout",
  orderIn: "Your order is in",
  waitingTitle: "Waiting for Moo Moo to confirm",
  waitingSub: "Please wait. The office usually answers within a few minutes.",
  confirmedSub: "Your milk is booked for %1.",
  onWaySub: "The driver is coming with your milk.",
  deliveredSub: "Enjoy your milk.",
  cancelledSub: "This order was cancelled.",
  cancelAsk: "Cancel this order?",
  cancelWhyMine: "Tell us why, so the office knows.",
  keepOrder: "Keep my order",
  reasonMistake: "Ordered by mistake",
  reasonWrongAddress: "Wrong address",
  reasonChangedMind: "Changed my mind",
  tooLate: "Your order is already on its way. Please call us to change it.",
  needChange: "Need to change something? Call %1",
  needChangeNoPhone: "Need to change something? Call the office.",
  officeAccept: "Accept order",
  officeNew: "New",
  installTitle: "Install the app",
  installSub: "Put Moo Moo on your home screen. Opens full screen, one tap to order, no app store needed.",
  installButton: "Install app",
  installDone: "Installed. Open Moo Moo from your home screen.",
  installOpenShop: "Open the shop",
  installAndroidManual: "Tap the menu at the top right of the browser, then \"Add to Home screen\" or \"Install app\".",
  installIos1: "Tap Share at the bottom of Safari.",
  installIos2: "Scroll down and tap \"Add to Home Screen\".",
  installIos3: "Tap Add. Moo Moo appears with your other apps.",
  installInApp: "This link opened inside another app. Open it in Chrome or Safari first.",
  installInAppHow: "Tap the menu (three dots) and choose \"Open in browser\".",
  installCopy: "Copy link",
  installCopied: "Copied",
  installQr: "Scan to open on another phone",
  installHint: "Install the app for one-tap ordering",
  installLater: "Later",
  installStaff: "Staff: install the office app",
  callUsShort: "Call us",
  deliveryToday: "Milk comes today",
  deliveryTomorrow: "Milk comes tomorrow morning",
  hurry: "Hurry, the truck leaves in",
  payCashLine: "Pay the driver in cash when the milk arrives.",
  forBusiness: "Shops and cafés: order at trade prices",
  installOfficeTitle: "Install the office app",
  installOfficeSub: "A second icon, Moo Moo Office, that opens straight on the delivery board. For the office and the drivers only.",
  installOfficeDone: "Installed. Open Moo Moo Office from your home screen.",
  installOfficeNote: "If an older Moo Moo icon opens the shop instead, delete it and install again from this page.",
} as const;

type Key = keyof typeof EN;

const KH: Partial<Record<Key, string>> = {
  brand: "មូមូ ហ្វាម",
  deliverTo: "ដឹកទៅ",
  milkToday: "ទឹកដោះគោថ្ងៃនេះ",
  milkTomorrow: "ទឹកដោះគោថ្ងៃស្អែក",
  cutoffOpen: "បញ្ជាទិញមុនម៉ោង ៩ ព្រឹក",
  cutoffShut: "ឡានចេញហើយថ្ងៃនេះ។ បញ្ជាទិញឥឡូវ ដឹកព្រឹកស្អែក។",
  left: "នៅសល់",
  search: "ស្វែងរកទឹកដោះគោ",
  popular: "ពេញនិយម",
  allMilk: "ទឹកដោះគោទាំងអស់",
  products: "ផលិតផល",
  inStock: "មានស្តុក",
  onlyLeft: "នៅសល់ %1",
  soldOut: "អស់ស្តុក",
  perBottle: "ក្នុងមួយដប",
  bottles: "ដប",
  viewCart: "មើលកន្ត្រក",
  yourCart: "កន្ត្រករបស់អ្នក",
  cartEmpty: "គ្មានទំនិញក្នុងកន្ត្រក",
  cartEmptySub: "បន្ថែមទឹកដោះគោ វានឹងបង្ហាញនៅទីនេះ។",
  subtotal: "សរុបរង",
  delivery: "សេវាដឹកជញ្ជូន",
  free: "ឥតគិតថ្លៃ",
  total: "សរុប",
  checkout: "បញ្ជាទិញ",
  back: "ត្រឡប់",
  yourName: "ឈ្មោះ",
  phone: "លេខទូរស័ព្ទ",
  address: "អាសយដ្ឋានដឹកជញ្ជូន",
  driverNote: "សម្គាល់សម្រាប់អ្នកដឹកជញ្ជូន",
  whereTo: "ដឹកទៅណា?",
  useMyLocation: "ខ្ញុំនៅផ្ទះឥឡូវ ប្រើទីតាំងខ្ញុំ",
  locating: "កំពុងរកទីតាំងអ្នក…",
  dragMap: "អូសផែនទី ឱ្យម្ជុលក្រហមនៅលើផ្ទះអ្នក",
  confirmPin: "ដឹកមកទីនេះ",
  changePin: "ប្តូរ",
  pinSet: "បានកំណត់ទីតាំង",
  quoting: "កំពុងគណនាចម្ងាយ…",
  estimated: "ប៉ាន់ស្មាន",
  outsideArea: "ទីតាំងនេះនៅក្រៅតំបន់ដឹកជញ្ជូនរបស់យើង។",
  callUs: "សូមទូរស័ព្ទមក %1",
  quoteFailed: "គណនាចម្ងាយមិនបាន។ សូមផ្លាស់ទីម្ជុល។",
  needPin: "សូមកំណត់ទីតាំងលើផែនទីជាមុន",
  pricedAtCheckout: "សេវាដឹកជញ្ជូនគិតតាមទីតាំងនៅពេលបញ្ជាទិញ",
  gpsDenied: "មិនបានអនុញ្ញាតទីតាំង។ សូមអូសផែនទីទៅទ្វារផ្ទះអ្នក។",
  feeHow: "សេវាដឹកជញ្ជូន $0.40 បូក $0.10 ក្នុងមួយគីឡូម៉ែត្រ គិតពីការិយាល័យច្បារអំពៅ។",
  cashOnDelivery: "បង់សាច់ប្រាក់ពេលដឹកដល់",
  cashHow: "អ្នកដឹកជញ្ជូនរបស់យើងទទួល %1 ពេលទឹកដោះគោមកដល់។ KHQR នឹងមកដល់ឆាប់ៗ។",
  paymentInvoice: "វិក្កយបត្រ ៣០ ថ្ងៃ",
  paid: "បានបង់ប្រាក់",
  unpaid: "មិនទាន់បង់ប្រាក់",
  placeOrder: "បញ្ជូនការបញ្ជាទិញ",
  sending: "កំពុងបញ្ជូន…",
  yourOrder: "ការបញ្ជាទិញរបស់អ្នក",
  stagePlaced: "បានបញ្ជាទិញ",
  stageConfirmed: "មូមូបានបញ្ជាក់",
  stagePacked: "បានខ្ចប់",
  stageOnTheWay: "កំពុងដឹកមក",
  stageDelivered: "បានដឹកដល់",
  stageCancelled: "បានបោះបង់",
  driver: "អ្នកដឹកជញ្ជូន",
  orderAgain: "បញ្ជាទិញម្តងទៀត",
  retry: "ព្យាយាមម្តងទៀត",
  loading: "កំពុងបើកហាង…",
  staleWarning: "ស្តុកអាចមិនទាន់ថ្មីបំផុត។",
  offline: "អ្នកគ្មានអ៊ីនធឺណិត។ កន្ត្រករបស់អ្នកត្រូវបានរក្សាទុក។",
  wholesale: "អាជីវកម្ម",
  retail: "អតិថិជន",
  poNumber: "លេខ PO របស់អ្នក",
  terms: "លក្ខខណ្ឌបង់ប្រាក់",
  termsValue: "៣០ ថ្ងៃ វិក្កយបត្រពេលដឹកជញ្ជូន",
  noFeeWholesale: "គ្មានសេវាដឹកជញ្ជូន៖ ការបញ្ជាទិញរបស់អ្នកឡើងឡានដែលយើងរត់រួចហើយ។",
  crateStep: "ការបញ្ជាទិញអាជីវកម្មគិតជាកេស ៦ ដប។",
  businessCode: "កូដអាជីវកម្ម",
  businessCodeHow: "សូមសួរការិយាល័យយកកូដ ដើម្បីបញ្ជាទិញតាមតម្លៃលក់ដុំ។",
  enter: "បញ្ចូល",
  cancel: "បោះបង់",
  notePlaceholder: "លេខកូដទ្វារ ជាន់ ចំណុចសម្គាល់",
  poPlaceholder: "ឧ. GF-0912",
  priceNote: "តម្លៃត្រូវបានបញ្ជាក់ដោយប្រព័ន្ធរបស់យើងនៅពេលបញ្ជាទិញ មិនមែនដោយទំព័រនេះទេ។",
  stillBooking: "ការបញ្ជាទិញរបស់អ្នកនៅជាមួយយើង។ កំពុងចុះក្នុងប្រព័ន្ធការិយាល័យ។",
  noMatch: "គ្មានទឹកដោះគោត្រូវនឹងការស្វែងរកនេះទេ។",
  clampNotice: "%2 នៅសល់តែ %1 ប៉ុណ្ណោះ។",
  errName: "សូមបញ្ចូលឈ្មោះរបស់អ្នក។",
  errPhone: "សូមបញ្ចូលលេខទូរស័ព្ទកម្ពុជា ឧ. 012 345 678។",
  errAddress: "សូមផ្តល់អាសយដ្ឋានដែលអ្នកដឹកជញ្ជូនអាចរកឃើញ។",
  errPin: "សូមកំណត់ទីតាំងលើផែនទី ដើម្បីឱ្យយើងដឹងថាដឹកទៅណា។",
  errStale: "យើងមិនអាចភ្ជាប់ប្រព័ន្ធស្តុកបានទេ។ សូមព្យាយាមម្តងទៀតបន្តិចទៀត។",
  errUnavailable: "ទឹកដោះគោខ្លះលែងមានគ្រប់ចំនួនហើយ។ សូមពិនិត្យកន្ត្រករបស់អ្នក។",
  errEmpty: "អ្វីៗក្នុងកន្ត្រករបស់អ្នកទើបតែអស់ស្តុក។",
  errOutside: "ទីតាំងនេះនៅក្រៅតំបន់ដឹកជញ្ជូនរបស់យើង។",
  errWholesaleClosed: "ការបញ្ជាទិញអាជីវកម្មមិនទាន់បើកទេ។",
  errWholesaleCode: "កូដអាជីវកម្មនេះមិនត្រឹមត្រូវទេ។",
  errOffline: "អ្នកហាក់ដូចជាគ្មានអ៊ីនធឺណិត។ សូមពិនិត្យការភ្ជាប់ រួចព្យាយាមម្តងទៀត។",
  errNetwork: "យើងមិនអាចភ្ជាប់ទៅ Moo Moo Farms បានទេ។ សូមព្យាយាមម្តងទៀត។",
  errGeneric: "មានបញ្ហាកើតឡើង។ សូមព្យាយាមម្តងទៀត។",
  shopError: "មិនអាចបើកហាងបានទេ។",
  addLabel: "បន្ថែម %1",
  errRateLimited: "សំណើច្រើនពេកពីទូរស័ព្ទនេះ។ សូមរង់ចាំមួយនាទី។",
  reorderThis: "បញ្ជាទិញដូចនេះម្តងទៀត",
  reorderLast: "បញ្ជាទិញដូចលើកមុនម្តងទៀត",
  backToShop: "ត្រឡប់ទៅហាង",
  officeTitle: "ការិយាល័យ",
  officePin: "កូដ PIN ការិយាល័យ",
  officeEnter: "បើក",
  officeOff: "ទំព័រការិយាល័យមិនទាន់រៀបចំទេ។ សូមសួរ James ឱ្យកំណត់ OFFICE_PIN។",
  officeBadPin: "PIN នេះមិនត្រឹមត្រូវទេ។",
  officeLocked: "ព្យាយាមច្រើនដងពេក។ សូមរង់ចាំ ១០ នាទី។",
  tabToday: "ថ្ងៃនេះ",
  tabOpen: "កំពុងដំណើរការ",
  tabAll: "ទាំងអស់",
  countToDeliver: "ត្រូវដឹក",
  countOnWay: "កំពុងដឹក",
  countDelivered: "បានដឹកដល់",
  countCash: "សាច់ប្រាក់ទទួល",
  noOrders: "គ្មានការបញ្ជាទិញនៅទីនេះទេ។",
  call: "ទូរស័ព្ទ",
  map: "ផែនទី",
  takeIt: "យកទៅដឹក",
  handedOver: "បានដឹកដល់",
  deliveredWhat: "បានប្រគល់អ្វីខ្លះ?",
  reasonWhy: "ហេតុអ្វីខ្វះ?",
  paymentAtDoor: "ការបង់ប្រាក់នៅមុខផ្ទះ",
  payCash: "ទទួលសាច់ប្រាក់",
  payKhqrDone: "បង់តាម KHQR",
  payNotYet: "មិនទាន់បង់",
  confirmDelivery: "បញ្ជាក់ការដឹកជញ្ជូន",
  cancelOrder: "បោះបង់ការបញ្ជាទិញ",
  cancelWhy: "ហេតុអ្វីបោះបង់?",
  reasonBroken: "ខូច",
  reasonReturn: "ត្រឡប់",
  reasonExpiry: "ជិតផុតកំណត់",
  reasonRefused: "មិនយក",
  reasonOther: "ផ្សេងៗ",
  noteLabel: "ចំណាំ",
  ordered: "បានបញ្ជាទិញ",
  invoice: "វិក្កយបត្រ",
  signOut: "ចាក់សោ",
  businessAsk: "អតិថិជនអាជីវកម្ម?",
  switchRetail: "តម្លៃអតិថិជន",
  addMore: "បន្ថែមទឹកដោះគោទៀត",
  atCheckout: "គិតពេលបញ្ជាទិញ",
  orderIn: "បានទទួលការបញ្ជាទិញ",
  waitingTitle: "រង់ចាំមូមូបញ្ជាក់",
  waitingSub: "សូមរង់ចាំ។ ជាធម្មតាការិយាល័យឆ្លើយតបក្នុងពេលប៉ុន្មាននាទី។",
  confirmedSub: "ទឹកដោះគោរបស់អ្នកបានកក់សម្រាប់ថ្ងៃ %1។",
  onWaySub: "អ្នកដឹកជញ្ជូនកំពុងមកជាមួយទឹកដោះគោរបស់អ្នក។",
  deliveredSub: "សូមរីករាយជាមួយទឹកដោះគោ។",
  cancelledSub: "ការបញ្ជាទិញនេះត្រូវបានបោះបង់។",
  cancelAsk: "បោះបង់ការបញ្ជាទិញនេះ?",
  cancelWhyMine: "ប្រាប់យើងពីមូលហេតុ ដើម្បីឱ្យការិយាល័យដឹង។",
  keepOrder: "រក្សាការបញ្ជាទិញ",
  reasonMistake: "បញ្ជាទិញច្រឡំ",
  reasonWrongAddress: "អាសយដ្ឋានខុស",
  reasonChangedMind: "ប្តូរចិត្ត",
  tooLate: "ការបញ្ជាទិញរបស់អ្នកកំពុងដឹកមកហើយ។ សូមទូរស័ព្ទមកយើងដើម្បីប្តូរ។",
  needChange: "ត្រូវការប្តូរអ្វី? ទូរស័ព្ទ %1",
  needChangeNoPhone: "ត្រូវការប្តូរអ្វី? សូមទូរស័ព្ទមកការិយាល័យ។",
  officeAccept: "ទទួលការបញ្ជាទិញ",
  officeNew: "ថ្មី",
  installTitle: "ដំឡើងកម្មវិធី",
  installSub: "ដាក់ Moo Moo លើអេក្រង់ទូរស័ព្ទអ្នក។ បើកពេញអេក្រង់ ចុចម្តងបញ្ជាទិញបាន មិនត្រូវការ App Store ទេ។",
  installButton: "ដំឡើងកម្មវិធី",
  installDone: "បានដំឡើងហើយ។ បើក Moo Moo ពីអេក្រង់ទូរស័ព្ទអ្នក។",
  installOpenShop: "បើកហាង",
  installAndroidManual: "ចុចម៉ឺនុយនៅជ្រុងខាងលើស្តាំនៃ browser រួចចុច \"Add to Home screen\" ឬ \"Install app\"។",
  installIos1: "ចុច Share នៅខាងក្រោម Safari។",
  installIos2: "រំកិលចុះក្រោម រួចចុច \"Add to Home Screen\"។",
  installIos3: "ចុច Add។ Moo Moo នឹងបង្ហាញជាមួយកម្មវិធីផ្សេងទៀត។",
  installInApp: "តំណនេះបើកក្នុងកម្មវិធីផ្សេង។ សូមបើកក្នុង Chrome ឬ Safari ជាមុនសិន។",
  installInAppHow: "ចុចម៉ឺនុយ (ចំណុចបី) រួចជ្រើស \"Open in browser\"។",
  installCopy: "ចម្លងតំណ",
  installCopied: "បានចម្លង",
  installQr: "ស្កេនដើម្បីបើកលើទូរស័ព្ទផ្សេង",
  installHint: "ដំឡើងកម្មវិធី ដើម្បីបញ្ជាទិញបានលឿន",
  installLater: "ពេលក្រោយ",
  installStaff: "បុគ្គលិក៖ ដំឡើងកម្មវិធីការិយាល័យ",
  callUsShort: "ទូរស័ព្ទមកយើង",
  deliveryToday: "ដឹកដល់ថ្ងៃនេះ",
  deliveryTomorrow: "ដឹកដល់ព្រឹកស្អែក",
  hurry: "ប្រញាប់ ឡានចេញក្នុង",
  payCashLine: "បង់សាច់ប្រាក់ឱ្យអ្នកដឹក ពេលទឹកដោះគោមកដល់។",
  forBusiness: "ហាង និងកាហ្វេ៖ បញ្ជាទិញតាមតម្លៃលក់ដុំ",
  installOfficeTitle: "ដំឡើងកម្មវិធីការិយាល័យ",
  installOfficeSub: "រូបតំណាងទីពីរ Moo Moo Office បើកត្រង់ទៅផ្ទាំងដឹកជញ្ជូន។ សម្រាប់ការិយាល័យ និងអ្នកដឹកតែប៉ុណ្ណោះ។",
  installOfficeDone: "បានដំឡើងហើយ។ បើក Moo Moo Office ពីអេក្រង់ទូរស័ព្ទអ្នក។",
  installOfficeNote: "បើរូបតំណាង Moo Moo ចាស់បើកទៅហាង សូមលុបវា រួចដំឡើងម្តងទៀតពីទំព័រនេះ។",
};

export function useLang() {
  const [lang, setLang] = useState<Lang>("kh");
  const t = useCallback(
    (key: Key, arg?: string | number, arg2?: string | number) => {
      const raw = (lang === "kh" ? KH[key] : undefined) ?? EN[key];
      const once = arg === undefined ? raw : raw.replace("%1", String(arg));
      return arg2 === undefined ? once : once.replace("%2", String(arg2));
    },
    [lang],
  );
  return { lang, setLang, t, toggle: () => setLang((l) => (l === "en" ? "kh" : "en")) };
}

export type Translate = ReturnType<typeof useLang>["t"];

/** Turns an API error into the customer's language. Never shows a raw server string. */
export function errorText(t: Translate, error: { code: string; status: number } | undefined): string {
  switch (error?.code) {
    case "stale_catalog":
    case "erp_unavailable":
      return t("errStale");
    case "unavailable_lines":
      return t("errUnavailable");
    case "empty_after_pricing":
      return t("errEmpty");
    case "outside_area":
      return t("errOutside");
    case "wholesale_closed":
      return t("errWholesaleClosed");
    case "bad_wholesale_code":
      return t("errWholesaleCode");
    case "rate_limited":
      return t("errRateLimited");
    case "too_late":
      return t("tooLate");
    case "offline":
      return t("errOffline");
    case "network":
      return t("errNetwork");
    default:
      return t("errGeneric");
  }
}

/** Field errors by path, so a zod message never reaches the screen. */
export function fieldText(t: Translate, path: string): string | undefined {
  switch (path) {
    case "customerName":
      return t("errName");
    case "phone":
      return t("errPhone");
    case "address":
      return t("errAddress");
    case "location":
      return t("errPin");
    default:
      return undefined;
  }
}
